import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/shaanxi/index.vue"),
  },
  // {
  //   path: "/courseTrain",
  //   name: "courseTrain",
  //   component: () => import("../views/courseTrain/index.vue"),
  // },
  // {
  //   path: "/xian",
  //   name: "xian",
  //   component: () => import("../views/xian/index.vue"),
  // },
  // {
  //   path: "/unitTrain",
  //   name: "unitTrain",
  //   component: () => import("../views/unitTrain/index.vue"),
  // },
  // {
  //   path: "/student",
  //   name: "student",
  //   component: () => import("../views/student/index.vue"),
  // },
  // {
  //   path: "/user",
  //   name: "user",
  //   component: () => import("../views/user/index.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.name === "student") {
    store.commit("app/setKeepAlive", "student");
  }
  if (from.name === "student" && to.name !== "user") {
    store.commit("app/removeKeepAlive", "student");
  }
  next();
});
export default router;
